// extracted by mini-css-extract-plugin
export default {"rootParent":"search_rootParent__kWzYr","mainParent":"search_mainParent__GtFso","root":"search_root__XruBJ","contentArea":"search_contentArea__c6mfI"};